// Do Me — Shopify theme JS (scroll reveals + minor interactions)
(function () {
  function onReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else { cb(); }
  }

  onReady(function () {
    // Scroll-reveal: any .dm-on-scroll element flips to .dm-in when in view.
    var io;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('dm-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });
      document.querySelectorAll('.dm-on-scroll').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.dm-on-scroll').forEach(function (el) { el.classList.add('dm-in'); });
    }

    // Filter chips on bestsellers — toggle .is-active visually only
    document.querySelectorAll('[data-dm-chips]').forEach(function (group) {
      group.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
  });
})();
